"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _runtime = require("../runtime");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var _default = (0, _runtime.IconWrapper)('hourglass-full', function (props) {
  return _react.default.createElement("svg", {
    width: props.size,
    height: props.size,
    viewBox: "0 0 48 48",
    xmlns: "http://www.w3.org/2000/svg"
  }, _react.default.createElement("g", {
    stroke: "none",
    strokeWidth: props.strokeWidth,
    fill: "none",
    fillRule: "evenodd",
    strokeLinejoin: props.strokeLinejoin
  }, _react.default.createElement("g", {
    transform: "translate(7.000000, 3.500000)",
    strokeWidth: props.strokeWidth
  }, _react.default.createElement("path", {
    d: "M0,0.5 L34,0.5",
    stroke: props.outStrokeColor,
    strokeLinecap: props.strokeLinecap
  }), _react.default.createElement("path", {
    d: "M0,40.5 L34,40.5",
    stroke: props.outStrokeColor,
    strokeLinecap: props.strokeLinecap
  }), _react.default.createElement("path", {
    d: "M30,20.4999965 C27.3333333,33.8388874 23,40.5055541 17,40.4999965 C11,40.494439 6.66666667,33.8277723 4,20.4999965 L30,20.4999965 Z",
    stroke: props.outStrokeColor,
    fill: props.outFillColor,
    fillRule: "nonzero",
    transform: "translate(17.000000, 30.499998) rotate(180.000000) translate(-17.000000, -30.499998) "
  }), _react.default.createElement("path", {
    d: "M30,0.5 C27.3333333,13.8388909 23,20.5055575 17,20.5 C11,20.4944425 6.66666667,13.8277758 4,0.5 L30,0.5 Z",
    stroke: props.outStrokeColor,
    fill: props.outFillColor,
    fillRule: "nonzero"
  }), _react.default.createElement("path", {
    d: "M14,11.5 L20,11.5",
    stroke: props.innerStrokeColor,
    strokeLinecap: props.strokeLinecap
  }), _react.default.createElement("path", {
    d: "M12,34.5 L22,34.5",
    stroke: props.innerStrokeColor,
    strokeLinecap: props.strokeLinecap
  }))));
});

exports.default = _default;